/* eslint-disable no-confusing-arrow */
import clsx from "clsx";
import { GridIcon, ListIcon } from "components/atoms/Icon";
import BrandDetailsCard from "components/molecules/brand/BrandDetailsCard";
import BrandDetailsCardSkeletonMultiple from "components/skeltons/BrandDetailsCardSkeletonMultiple";
import { Link } from "react-router-dom";
import { useLocalStorage, useRouter } from "../../components/hooks";
import MagnetCarousel from "../../components/molecules/magnet/MagnetCarousel";
import Footer from "../../components/pageComponents/Footer/Footer";
import { LOCAL_STORAGE_KEYS, ROUTES } from "../../constants";
import { Brand } from "../../models";
import { Cover } from "./components";

interface IProps {
  brands: Array<Brand>;
  brandsLoading: Boolean;
  // tags: Array<string>;
  // onTagClick: (tagName: string) => void;
  trendingMagnets: PublicMagnet[];
  onLastElementVisible: () => void;
  trendingMagnetsLoading: boolean;
}
function BrandDiscoverComponent({
  brands,
  trendingMagnets,
  brandsLoading,
  trendingMagnetsLoading,
  onLastElementVisible,
}: IProps) {
  const router = useRouter();

  // const {
  //   setWalkthroughRun,
  //   handleNavigateToMagnetiqBrandPublicProfile,
  //   walkthroughData: { run: isWalkThroughRunning },
  // } = useWalkthroughContext();

  const handleNavigateToBrandPublicProfile = () => {
    router.go("#");
  };

  const [activeLayout, setActiveLayout] = useLocalStorage<0 | 1>(LOCAL_STORAGE_KEYS.DISCOVER_PAGE_LAYOUT, 0);

  const handleSetLayout = (layoutNumberToSet: 0 | 1) => {
    setActiveLayout(layoutNumberToSet);
  };

  // const handleBrandCardClickOnOnboarding = () => {
  //   setWalkthroughRun(false);
  //   handleNavigateToMagnetiqBrandPublicProfile();
  // };

  return (
    <div className="bg-primary px-1 pt-2 md:px-3">
      <div className="flex flex-row content-center justify-between">
        <span className="font-sora text-2xl font-semibold text-white md:text-4xl lg:text-5xl">Discover Brands</span>
        {/* <FilterButtons onFilterSelect={onTagClick} className="" filterOptions={["All", ...tags]} /> */}
        <div className="flex space-x-2 md:space-x-4">
          <button type="button" className={clsx(activeLayout !== 0 && "opacity-40")} onClick={() => handleSetLayout(0)}>
            <GridIcon />
          </button>
          <button type="button" className={clsx(activeLayout !== 1 && "opacity-40")} onClick={() => handleSetLayout(1)}>
            <ListIcon />
          </button>
        </div>
      </div>
      <div
        className={clsx(
          "grid",
          activeLayout === 1
            ? "grid-cols-1"
            : "mt-10 gap-x-6  gap-y-8 lg:grid-cols-2 xl:grid-cols-3 2xl:mt-14 2xl:gap-x-7 2xl:gap-y-14 4xl:grid-cols-4",
        )}
      >
        {brandsLoading ? (
          <BrandDetailsCardSkeletonMultiple count={10} />
        ) : (
          brands.map((brand) =>
            activeLayout === 1 ? (
              <Link key={brand.id} to={`${ROUTES.BRAND_PUBLIC_PROFILE}/${brand.id}`}>
                <Cover className="mt-14" imageSrc={brand.cover_image_url}>
                  <Cover.Card
                    onAction={() =>
                      // isWalkThroughRunning
                      //   ? handleBrandCardClickOnOnboarding()
                      //   :
                      handleNavigateToBrandPublicProfile()
                    }
                    imageSrc={brand.profile_image_url}
                    title={brand.name}
                    description={brand.about}
                  />
                </Cover>
              </Link>
            ) : (
              <BrandDetailsCard
                brandId={brand.id}
                key={brand.id}
                brandProfileImage={brand.profile_image_url}
                brandName={brand.name}
                brandDescription={brand.about}
                brandCoverImage={brand.cover_image_url}
              />
            ),
          )
        )}
      </div>

      <div className="mt-8 md:mt-14 2xl:mt-16">
        {trendingMagnets.length ? (
          <>
            <p className="mb-2 font-sora text-xl font-semibold text-white 2xl:text-2xl">Trending Magnets</p>
            <div className="rounded-2xl bg-opacity-30 p-2">
              <MagnetCarousel
                magnets={trendingMagnets}
                onLastElementVisible={onLastElementVisible}
                trendingMagnetsLoading={trendingMagnetsLoading}
              />
            </div>
          </>
        ) : null}
      </div>
      <Footer />
    </div>
  );
}

export default BrandDiscoverComponent;
